<script setup lang="ts">
import { computed } from "vue";
import { useThemeStore } from "@/stores/theme";

/**
 * Single button that cycles `system → light → dark`. The icon + label
 * track the current mode. Tooltip shows what's active and what's
 * coming next so the click never feels surprising.
 */
const theme = useThemeStore();

const label = computed(() => {
  switch (theme.mode) {
    case "system":
      return `Järjestelmä (${theme.effective === "dark" ? "tumma" : "vaalea"})`;
    case "light":
      return "Vaalea";
    case "dark":
      return "Tumma";
  }
});

const icon = computed(() => {
  switch (theme.mode) {
    case "system":
      return "🖥";
    case "light":
      return "☀";
    case "dark":
      return "🌙";
  }
});

const nextLabel = computed(() => {
  switch (theme.mode) {
    case "system":
      return "Vaihda: vaalea";
    case "light":
      return "Vaihda: tumma";
    case "dark":
      return "Vaihda: järjestelmä";
  }
});
</script>

<template>
  <button
    type="button"
    class="theme-toggle"
    :title="nextLabel"
    @click="theme.cycle()"
  >
    <span class="icon" aria-hidden="true">{{ icon }}</span>
    <span class="lbl">{{ label }}</span>
  </button>
</template>

<style scoped>
.theme-toggle {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.3rem 0.7rem;
  border-radius: 4px;
  font-size: 0.78rem;
  background: var(--surface, white);
  color: var(--text-muted, #6b7280);
  border: 1px solid var(--border, #d1d5db);
  cursor: pointer;
}
.theme-toggle:hover {
  background: var(--surface-2, #f3f4f6);
  color: var(--text-strong, #111827);
}
.icon { font-size: 0.95rem; line-height: 1; }
.lbl { white-space: nowrap; }
</style>
